import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { FluentProvider } from '@fluentui/react-components';
import { Layout } from './components/layout/Layout';
import { Dashboard } from './pages/Dashboard';
import { ProjectDetails } from './pages/ProjectDetails';
import { CashFlow } from './pages/CashFlow';
import { Tenants } from './pages/Tenants';
import { Reports } from './pages/Reports';
import { Sensitivity } from './pages/Sensitivity';
import { Scenarios } from './pages/Scenarios';
import { lightTheme } from './styles/theme';
import { ROUTES } from './utils/constants';
import './styles/index.css';

function App() {
  return (
    <FluentProvider theme={lightTheme}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path={ROUTES.PROJECT_DETAILS} element={<ProjectDetails />} />
            <Route path={ROUTES.CASH_FLOW} element={<CashFlow />} />
            <Route path={ROUTES.TENANTS} element={<Tenants />} />
            <Route path={ROUTES.REPORTS} element={<Reports />} />
            <Route path={ROUTES.SENSITIVITY} element={<Sensitivity />} />
            <Route path={ROUTES.SCENARIOS} element={<Scenarios />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </FluentProvider>
  );
}

export default App;
